/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './checkSignupQueue.defs'
export { main as default } from './checkSignupQueue.defs'
